import { css } from "@emotion/react";
import { styled } from "@mui/material/styles";
import { CellContext } from "@tanstack/react-table";
import Guard from "components/Guard/Guard";
import { isEmpty } from "lodash";
import {
  ApplicationHistoryEventType,
  ApplicationHistoryFieldDisplayName,
  IApplicationHistoryEntity,
  IApplicationHistoryEventData,
} from "models/Application.model";
import React from "react";
import { useTranslation } from "react-i18next";
import ParticipantChangeListItem from "./ParticipantChangeListItem";

type Props = CellContext<IApplicationHistoryEntity, any>;

const ParticipantHistoryTableDetailsCell: React.FC<Props> = ({ row, getValue }) => {
  const { t } = useTranslation();

  const eventType = row.original.eventType;
  const delta = getValue<IApplicationHistoryEventData>().delta || {};
  const deltaKeys = Object.keys(delta);

  return (
    <div data-testid={"ParticipantHistoryTableDetailsCell"}>
      <Guard condition={eventType === ApplicationHistoryEventType.ParticipantAdded}>{t("Added participant")}</Guard>
      <Guard condition={eventType === ApplicationHistoryEventType.ParticipantRemoved}>{t("Removed participant")}</Guard>
      <Guard condition={eventType === ApplicationHistoryEventType.ParticipantRestored}>
        {t("Restored participant")}
      </Guard>
      <Guard condition={eventType === ApplicationHistoryEventType.ParticipantUpdated}>
        <Guard condition={!isEmpty(deltaKeys)} fallback={t("Updated participant")}>
          <StyledList $showPoints={deltaKeys.length > 1}>
            {deltaKeys.map((deltaKey) => {
              const [before, after] = delta[deltaKey];
              const displayName = ApplicationHistoryFieldDisplayName[deltaKey];

              return (
                <ParticipantChangeListItem key={deltaKey} displayName={displayName} before={before} after={after} />
              );
            })}
          </StyledList>
        </Guard>
      </Guard>
    </div>
  );
};

const StyledList = styled("ul", { shouldForwardProp: (prop) => prop !== "$showPoints" })(
  ({ theme, $showPoints }) => css`
    padding-left: 16px;
    margin: 0;

    ${!$showPoints &&
    `
      padding-left: 0;
      list-style-type: none;
    `}
  `
);

export default ParticipantHistoryTableDetailsCell;
